module.exports = __webpack_public_path__ + "img/primitief vuur maken.a41fb339.jpg";